import cx from "classnames";

import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import FeedbackButton from "components/FeedbackButton";

import styles from "./styles.module.css";

type UserGuideGroupEmptyProps = {
  variant?: "default" | "assistantPanel";
};

const UserGuideGroupEmpty = ({ variant = "default" }: UserGuideGroupEmptyProps) => {
  const isAssistantPanel = variant === "assistantPanel";

  return (
    <Box
      direction="column"
      grow="1"
      align="center"
      justify={isAssistantPanel ? "start" : "center"}
      className={styles.container}
    >
      <Box
        direction="column"
        align="center"
        gap="x-large"
        className={cx(styles.wrapper, {
          [styles.wrapperAssistantPanel]: isAssistantPanel,
        })}
      >
        <div
          className={cx(styles.imageWrapper, {
            [styles.imageWrapperAssistantPanel]: isAssistantPanel,
          })}
        >
          <img
            src="/images/learning-path.png"
            alt="Learning path illustration"
            className={cx(styles.image, {
              [styles.imageAssistantPanel]: isAssistantPanel,
            })}
          />
        </div>
        <EmptyState
          title="This path is preparing for launch"
          caption="We're still building this learning track to help you master advanced workflows in Spacelift. Want to help shape it? Let us know what you'd like to learn, struggle with, or wish existed. The more we hear from you, the better it'll be."
          className={isAssistantPanel ? styles.emptyStateAssistantPanel : undefined}
        >
          <FeedbackButton
            id="user-guide-group-empty-feedback"
            variant="secondary"
            size={isAssistantPanel ? "small" : undefined}
          />
        </EmptyState>
      </Box>
    </Box>
  );
};

export default UserGuideGroupEmpty;
